var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.body != null)?_c('div',[_c('div',{staticClass:"lp_page",domProps:{"innerHTML":_vm._s(_vm.body)}})]):(_vm.isNotFound)?_c('div',[_c('NotFound')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }